import React from 'react';
import { SelectBox } from 'components/core/Form';
import { addDays, isSameDay } from 'date-fns';

import './UnitDropdownDatepicker.scss';

const DEFAULT_OPTION = {
	display: 'Select a date',
	disabled: true,
	value: '',
};

export const UnitDropdownDatepicker = ({
	reservationWindow,
	closures,
	today,
	...props
}) => {
	const options = Array.from({ length: reservationWindow + 1 }, (_, k) =>
		addDays(today, k),
	)
		.map((d) => ({
			value: d.toLocaleDateString('en-US'),
			disabled: closures.some((c) => isSameDay(c, d)),
			display: d.toLocaleDateString('en-US', {
				weekday: 'long',
				month: 'long',
				day: 'numeric',
			}),
		}))
		.reduce((a, d, i) => {
			if (d.display.includes('Sunday')) {
				return [
					...a,
					{ value: i, display: '---------', disabled: true },
					d,
				];
			}
			return [...a, d];
		}, []);

	return (
		<SelectBox
			id="unit-reservation-date-dropdown"
			className="dropdown-datepicker"
			errorMessage={props.errorMessage}
			{...props}
			options={[DEFAULT_OPTION, ...options]}
		/>
	);
};

UnitDropdownDatepicker.propTypes = {
	...SelectBox.propTypes,
};

export default UnitDropdownDatepicker;
